import React from 'react';
const MultiToggle = _ref => {
  let {
    setFilterChoiceState,
    items,
    filters,
    filterName,
    label
  } = _ref;
  const itemToggle = e => {
    setFilterChoiceState(e.currentTarget.checked, e.currentTarget.value, filterName, false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll"
  }, Object.keys(items).map((facetLabel, index) => /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item",
    key: `${facetLabel}-checkbox-index`
  }, /*#__PURE__*/React.createElement("input", {
    tabIndex: 0,
    type: "checkbox",
    onChange: itemToggle,
    id: `${filterName}-${index}`,
    name: `${filterName}-${index}`,
    checked: filters.includes(facetLabel),
    value: facetLabel,
    title: facetLabel
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: `${filterName}-${index}`
  }, facetLabel)))))));
};
export default MultiToggle;